/**
 * 全站的简单埋点统计
 */

(function ($) {

    $(function () {

        $('body').on('click', '[data-tongjilog]', function () {
            if (typeof _TongjiLog === 'undefined') {
                return;
            }

            var $this = $(this);
            var data = $this.data('tongjilog');
            var arr = data.split(',') || [];

            _TongjiLog(arr[0], arr[1]);
        });
    });

})(jQuery);



// WEBPACK FOOTER //
// ./src/module/trace.js